<template>
    <el-container>
        <el-main>
            <el-main style="height:calc(90vh);">
                <el-header> 
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 测评</el-breadcrumb-item>
                        <el-breadcrumb-item>DISC性格测评结果</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-header>
                <el-table
                :data="tableData" max-height="616px"
                style="width: 100%;margin-bottom:15px">
                    <el-table-column
                        prop="username"
                        label="姓名"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="result_type"
                        label="测试结果"
                        align="center"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        label="测试时间"
                        align="center"
                        width="220">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="230">
                        <template slot-scope="scope">
                            <el-button @click="getDiscResultData(scope.row.id)" type="text" size="small">PDF下载</el-button>
                        </template>
                        </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </el-main>





            <div id="pdfDom" style="width:1200px;display:none;">
                <div class="page-div">
                    <img :src="titleImg" style="margin-top:30%;margin-bottom:5%;width:100%;">
                    <el-row class="text-left" style="margin-bottom:10px">
                        <el-col :span="2" :offset="9">
                            <span>姓名：</span>
                        </el-col>
                        <el-col :span="11">
                            <span>{{username}}</span>
                        </el-col>
                    </el-row>
                    <el-row class="text-left">
                        <el-col :span="2" :offset="9">
                            <span>完成时间：</span>
                        </el-col>
                        <el-col :span="11">
                            <span>{{create_time}}</span>
                        </el-col>
                    </el-row>
                    <img :src="qrcodeImg" style="margin-top:100px;margin-bottom:5%;width:200px">
                    <el-row style="margin-bottom:200px">
                        <span>扫描二维码，关注「海蓝背调」</span>
                    </el-row>
                    <el-row style="margin-bottom:50px">
                        <span>本报告内容涉及个人隐私，请注意保密</span>
                    </el-row>
                    <el-row>
                        <span>海蓝背调 ● 版权所有</span>
                    </el-row>
                </div>
                <div class="page-div">
                    <el-row>
                        <el-col :span="4" :offset="1">
                            <span style="font-size:36px">前言</span>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:50px">
                        <el-col :span="8" :offset="2">
                            <img :src="prefaceImg" style="width:100%">
                        </el-col>
                        <el-col :span="11" :offset="1" class="text-left">
                            <p>行为方式不同，与之匹配的职位不同。</p>
                            <p>马斯顿博士采用非常典型的人格特质因子来衡量人群的情绪反映，即Dominance－支配，Influence－影响，Steady－稳健，以及Compliance－服从。</p>
                            <p>行为特征分析基于DISC理论，展现了四个基本风格，预见其可能的工作表现。利用DISC行为分析方法了解个体情感、工作特征、行为风格、沟通方式、能力特征、人际关系、优劣势等等。</p>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:100px">
                        <el-col :span="20" :offset="2" class="text-left">
                            <p>DISC性格测验是企业广泛应用的一种人格测验，用于测查、评估和帮助人们改善其行为方式、人际关系、工作绩效、团队合作、领导风格等。</p>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:200px">
                        <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                            <el-row>
                                <h2><i class="el-icon-warning"></i>&nbsp;&nbsp;查看报告提示</h2>
                            </el-row>
                            <el-row class="text-left">
                                <p>1、性格没有好与坏，测试的目的是反映最真实的自己，没有好坏优劣。</p>
                                <p>2、本报告是基于受测者对全部问题的回答所生成的评估结果，因此受测者的作答状态、自我认知和坦白程度等因素，均会影响其报告结果的真实性、准确性和有效性。</p>
                                <p>3、本报告的有效期为6至12个月，如果受测者的生活或工作发生重大变化，应考虑再次参与测评。</p>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>

                <div class="page-div">
                    <el-row>
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left">一、结果概要</h1>
                        </el-col>
                    </el-row>
                    <el-main>
                        <el-row :gutter="20" style="margin-top:10px;margin-bottom:20px;">
                            <el-col :span="16" :offset="4">
                                <div id="myChart" :style="{width: '100%', height: '380px'}"></div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                                <el-row>
                                    <h2>这种典型行为风格，<span style="color:#3b8ad9">可被大致描述为是"{{userdata.des}}"的类型</span></h2>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:50px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 47px;text-align: left;padding-left:20px;color:#fff">总结</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{userdata.describ}}</p>
                                <p>【<span>行为特征</span>】{{userdata.action}}</p>
                                <p>【<span>交流沟通</span>】{{userdata.comm}}</p>
                                <p>【<span>能力特征</span>】{{userdata.ability}}</p>
                                <p>【<span>行为优势</span>】{{userdata.advantage}}</p>
                                <p>【<span>行为弱势</span>】{{userdata.disadvantage}}</p>
                            </el-col>
                        </el-row>

                    </el-main>
                </div>
              
                <div class="page-div">
                    <el-row>
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left">二、工作情境下的行为表现</h1>
                        </el-col>
                    </el-row>
                    <el-main>
                        <el-row :gutter="20" style="margin-top:10px;margin-bottom:20px;">
                            <el-col :span="16" :offset="4">
                                <div id="mChart" :style="{width: '100%', height: '380px'}"></div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                                <el-row>
                                    <h2>{{disc_M.description}}</h2>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:50px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 47px;text-align: left;padding-left:20px;color:#fff">{{disc_M.title}} {{disc_M.type}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{disc_M.result}}</p>
                                <p>【<span>情感</span>】{{disc_M.emotion}}</p>
                                <p>【<span>工作</span>】{{disc_M.work}}</p>
                                <p>【<span>人际</span>】{{disc_M.relation}}</p>
                                <p>【<span>优势</span>】{{disc_M.advantage}}</p>
                                <p>【<span>弱势</span>】{{disc_M.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main> 
                </div>
                <div class="page-div">
                    <el-row>
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left">三、压力情绪下的行为风格</h1>
                        </el-col>
                    </el-row>
                    <el-main>
                        <el-row :gutter="20" style="margin-top:10px;margin-bottom:20px;">
                            <el-col :span="16" :offset="4">
                                <div id="lChart" :style="{width: '100%', height: '380px'}"></div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" :offset="2" style="background: #d6eafdc9;border-radius: 10px;padding:30px 50px">
                                <el-row>
                                    <h2>{{disc_L.description}}</h2>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:50px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 47px;text-align: left;padding-left:20px;color:#fff">{{disc_L.title}} {{disc_L.type}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{disc_L.result}}</p>
                                <p>【<span>情感</span>】{{disc_L.emotion}}</p>
                                <p>【<span>工作</span>】{{disc_L.work}}</p>
                                <p>【<span>人际</span>】{{disc_L.relation}}</p>
                                <p>【<span>优势</span>】{{disc_L.advantage}}</p>
                                <p>【<span>弱势</span>】{{disc_L.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                </div>
                <div class="page-div">
                    <el-row>
                        <el-col :span="10" :offset="2">
                            <h1 class="text-left">四、结果参考</h1>
                        </el-col>
                    </el-row>
                    <el-main>
                        <el-row style="margin-top:30px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 47px;text-align: left;padding-left:20px;color:#fff">{{disc_D.title}} {{disc_D.type}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{disc_D.result}}</p>
                                <p>【<span>情感</span>】{{disc_D.emotion}}</p>
                                <p>【<span>工作</span>】{{disc_D.work}}</p>
                                <p>【<span>人际</span>】{{disc_D.relation}}</p>
                                <p>【<span>优势</span>】{{disc_D.advantage}}</p>
                                <p>【<span>弱势</span>】{{disc_D.disadvantage}}</p>
                            </el-col>
                        </el-row>

                        <el-row style="margin-top:50px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 47px;text-align: left;padding-left:20px;color:#fff">{{disc_I.title}} {{disc_I.type}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{disc_I.result}}</p>
                                <p>【<span>情感</span>】{{disc_I.emotion}}</p>
                                <p>【<span>工作</span>】{{disc_I.work}}</p>
                                <p>【<span>人际</span>】{{disc_I.relation}}</p>
                                <p>【<span>优势</span>】{{disc_I.advantage}}</p>
                                <p>【<span>弱势</span>】{{disc_I.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                </div>
                <div class="page-div">
                    <el-main>
                        <el-row style="margin-top:30px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 47px;text-align: left;padding-left:20px;color:#fff">{{disc_S.title}} {{disc_S.type}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{disc_S.result}}</p>
                                <p>【<span>情感</span>】{{disc_S.emotion}}</p>
                                <p>【<span>工作</span>】{{disc_S.work}}</p>
                                <p>【<span>人际</span>】{{disc_S.relation}}</p>
                                <p>【<span>优势</span>】{{disc_S.advantage}}</p>
                                <p>【<span>弱势</span>】{{disc_S.disadvantage}}</p>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:50px">
                            <el-col :span="20" :offset="2">
                                <div :style="imgStyle">
                                    <h2 style="line-height: 47px;text-align: left;padding-left:20px;color:#fff">{{disc_C.title}} {{disc_C.type}}</h2>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px">
                            <el-col :span="20" :offset="2" class="text-left">
                                <p>{{disc_C.result}}</p>
                                <p>【<span>情感</span>】{{disc_C.emotion}}</p>
                                <p>【<span>工作</span>】{{disc_C.work}}</p>
                                <p>【<span>人际</span>】{{disc_C.relation}}</p>
                                <p>【<span>优势</span>】{{disc_C.advantage}}</p>
                                <p>【<span>弱势</span>】{{disc_C.disadvantage}}</p>
                            </el-col>
                        </el-row>
                    </el-main>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import json from "../../static/disc.json"
export default {
    name: 'disc-result',
    data () {
        return {
            msg: 'Welcome to Your Vue.js App',
            id : "",
            username:"",
            create_time:"",
            userdata : {},
            resdata : {},

            total: 1,
            pageSize:10,//每页的数据条数
            currentPage:1,//默认开始页面
            tableData: [],           

            mldData:[],
            mData:[],
            lData:[],
            
            disc_M:{},
            disc_L:{},
            disc_D:{},
            disc_I:{},
            disc_S:{},
            disc_C:{},


            htmlTitle: '导出PDF的标题',

            titleImg: require("../../assets/title.jpg"),
            qrcodeImg: require("../../assets/qrcode.jpg"),
            prefaceImg: require("../../assets/preface.jpg"),
            // bgImg: require("../../assets/bgimg.jpg"),

            imgStyle:{
                backgroundImage: `url(${require("../../assets/bgimg.jpg")})`, backgroundRepeat: 'no-repeat', width:'100%', height: '69px', 'background-size': '100% auto'
            }
        }
    },
    mounted() {
        console.log(this.$route.params.result_id)
        this.getDiscData();
        this.queryDiscResult();
    },
    methods: {
        queryDiscResult(){
            let params = {
                pageSize: this.pageSize,
                pageNumber: this.currentPage
            }
            this.$axios.post('/api/queryDiscResult', params).then( res => {
                this.tableData = res.data.rows;
                this.total = res.data.total;
            });
        },
        handleCurrentChange(currentPage){
			this.currentPage = currentPage;
            this.queryDiscResult();
        },
		handleSizeChange(pageSize){
			this.pageSize = pageSize;
            this.queryDiscResult();
		},
        getDiscData(){
            this.resdata = json;
            this.disc_D = json.D;
            this.disc_I = json.I;
            this.disc_S = json.S;
            this.disc_C = json.C;
        },

        getDiscResultData(result_id){
            //loading遮罩层
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
            this.$axios.post('/api/getDiscResultData', {result_id: result_id}).then( res => {
                this.id = result_id;
                this.username = res.data.username;
                this.create_time = res.data.create_time;
                this.userdata = res.data;                

                this.disc_M = this.resdata[res.data.max_m];
                this.disc_L = this.resdata[res.data.max_l];

                let ml_result = this.resdata.ml_result;
                let m_result = this.resdata.m_result;
                let l_result = this.resdata.l_result;


                this.mldData.length = 0;
                this.mldData.push(ml_result[parseInt(this.userdata.mld) + 21]["D"]);
                this.mldData.push(ml_result[parseInt(this.userdata.mli) + 19]["I"]);
                this.mldData.push(ml_result[parseInt(this.userdata.mls) + 19]["S"]);
                this.mldData.push(ml_result[parseInt(this.userdata.mlc) + 16]["C"]);

                this.mData.length = 0;
                this.mData.push(m_result[parseInt(this.userdata.md)]["D"]);
                this.mData.push(m_result[parseInt(this.userdata.mi)]["I"]);
                this.mData.push(m_result[parseInt(this.userdata.ms)]["S"]);
                this.mData.push(m_result[parseInt(this.userdata.mc)]["C"]);

                this.lData.length = 0;
                this.lData.push(l_result[parseInt(this.userdata.ld)]["D"]);
                this.lData.push(l_result[parseInt(this.userdata.li)]["I"]);
                this.lData.push(l_result[parseInt(this.userdata.ls)]["S"]);
                this.lData.push(l_result[parseInt(this.userdata.lc)]["C"]);

                //通过id获取
                var part =document.getElementById("pdfDom");
                //修改display
                part.style.display="block";

                this.loadMChart();
                this.loadLChart();
                this.drawLine(loading);
            });
        },

        drawLine(loading){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('myChart'))
            let option = {
                tooltip: {
                    formatter: function(){
                        return ''
                    }
                },
                grid: {
                    left:10,
                    right:10,
                    show:'true',
                    borderWidth:'2',
                    borderColor:"#9a9898cf",
                },
                xAxis: {
                    type: 'category',
                    data: ['D', 'I', 'S', 'C'],
                    position: 'top',
                    nameTextStyle: {
                        borderColor: "#9a9898cf",
                        borderWidth: 2
                    },
                    axisTick: {
                        show: true,
                        length: '0',
                        lineStyle: {
                            width:2
                        }
                    },
                    axisLabel: {
                        show: false
                    }
                },
                yAxis: {
                    show:false,
                    type: 'value',
                    max: 120,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
                series: [
                    {
                        name: '自我形象',
                        type: 'line',
                        data: this.mldData,
                        symbol: 'circle', //折线点设置为实心点
                        symbolSize: 10, //折线点的大小
                        smooth: true,
                        markArea: {
                            silent: true,
                            data: [
                                [
                                    {
                                        yAxis: 44,
                                        itemStyle: {
                                            color: '#ffdee061'
                                        },
                                    }, {
                                        yAxis: 57
                                    }
                                ]
                            ]
                        },
                        markLine : {
                            symbol:"none",
                            itemStyle:{
                                normal:{
                                    color:'#FA8565',
                                }
                            },
                            data : [
                                {
                                    silent:false, //鼠标悬停事件
                                     lineStyle:{ //警戒线的样式
                                        type:"solid", //样式  ‘solid’和‘dotted‘
                                        color:"#c82d31",
                                        width: 2   //宽度
                                    },
                                    yAxis: 51,
                                    label: {
                                        normal: {
                                            formatter: ''
                                        }
                                    }
                                },
                                {
                                    silent:false, //鼠标悬停事件
                                    lineStyle:{ //警戒线的样式
                                        type:"solid", //样式  ‘solid’和‘dotted‘
                                        color:"#9a9898cf",
                                        width: 2   //宽度
                                    },
                                    yAxis: 100,
                                    label: {
                                        normal: {
                                            formatter: ''
                                        }
                                    }
                                }
                            ]
                        },
                        markPoint: {
                            label: {
                                color: "#71a5d6",
                                fontWeight: "bold",
                                fontSize: 14
                            },
                            symbolSize:1,
                            data: [
                                {value: 'D', xAxis: 'D', yAxis: 110},
                                {value: 'I', xAxis: 'I', yAxis: 110},
                                {value: 'S', xAxis: 'S', yAxis: 110},
                                {value: 'C', xAxis: 'C', yAxis: 110},
                            ]

                        }
                    },{
                        data: [0,0,0,0],
                        type: 'bar',
                        barWidth: 50,
                        showBackground: true,
                        backgroundStyle: {
                            borderColor: "#9a9898cf",
                            borderWidth: 2,
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ],
                visualMap: [{
                    show: false,
                    type: 'continuous',
                    seriesIndex: 0,
                    min: 0,
                    max: 100,
                    pieces: [
                        { gte: 0, lt: 51, color: '#b8ddf0' },
                        // { gte: 40, lt: 60, color: '#e0bdb8' },
                        { gte: 51, lt: 100, color: '#EB190A' },
                    ]
                }]
            };
            // 绘制图表
            myChart.setOption(option);
            const that = this;
            setTimeout(function(){
                window.scrollTo(0,0);
                let pdf = that.getPdf();
                console.log(pdf)
                // that.$axios.post('/api/createPdfFile', {pdf,title:'222.pdf'}).then(  
                // );
                //通过id获取
                var part =document.getElementById("pdfDom");
                //修改display
                part.style.display="none";

                setTimeout(function(){
                    loading.close();
                },200);
            },1100);
        },
        
        loadMChart(){
            let mChart = this.$echarts.init(document.getElementById('mChart'))
            let option = {
                tooltip: {
                    formatter: function(){
                        return ''
                    }
                },
                grid: {
                    left:10,
                    right:10,
                    show:'true',
                    borderWidth:'2',
                    borderColor:"#9a9898cf",
                },
                xAxis: {
                    type: 'category',
                    data: ['D', 'I', 'S', 'C'],
                    position: 'top',
                    nameTextStyle: {
                        borderColor: "#9a9898cf",
                        borderWidth: 2
                    },
                    axisTick: {
                        show: true,
                        length: '0',
                        lineStyle: {
                            width:2
                        }
                    },
                    axisLabel: {
                        show: false
                    }
                },
                yAxis: {
                    show:false,
                    type: 'value',
                    max: 120,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
                series: [
                    {
                        name: '工作情境下的行为表现',
                        type: 'line',
                        data: this.mData,
                        symbol: 'circle', //折线点设置为实心点
                        symbolSize: 10, //折线点的大小
                        smooth: true,
                        markLine : {
                            symbol:"none",
                            itemStyle:{
                                normal:{
                                    color:'#FA8565',
                                }
                            },
                            data : [
                                {
                                    silent:false, //鼠标悬停事件
                                     lineStyle:{ //警戒线的样式
                                        type:"solid", //样式  ‘solid’和‘dotted‘
                                        color:"#c82d31",
                                        width: 2   //宽度
                                    },
                                    yAxis: 51,
                                    label: {
                                        normal: {
                                            formatter: ''
                                        }
                                    }
                                },
                                {
                                    silent:false, //鼠标悬停事件
                                    lineStyle:{ //警戒线的样式
                                        type:"solid", //样式  ‘solid’和‘dotted‘
                                        color:"#9a9898cf",
                                        width: 2   //宽度
                                    },
                                    yAxis: 100,
                                    label: {
                                        normal: {
                                            formatter: ''
                                        }
                                    }
                                }
                            ]
                        },
                        markPoint: {
                            label: {
                                color: "#71a5d6",
                                fontWeight: "bold",
                                fontSize: 14
                            },
                            symbolSize:1,
                            data: [
                                {value: 'D', xAxis: 'D', yAxis: 110},
                                {value: 'I', xAxis: 'I', yAxis: 110},
                                {value: 'S', xAxis: 'S', yAxis: 110},
                                {value: 'C', xAxis: 'C', yAxis: 110},
                            ]

                        }
                    },
                    {
                        data: [0,0,0,0],
                        type: 'bar',
                        barWidth: 50,
                        showBackground: true,
                        backgroundStyle: {
                            borderColor: "#9a9898cf",
                            borderWidth: 2,
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ],
                
            };
            // 绘制图表
            mChart.setOption(option);
        },
        loadLChart(){
            let lChart = this.$echarts.init(document.getElementById('lChart'))
            let option = {
                tooltip: {
                    formatter: function(){
                        return ''
                    }
                },
                grid: {
                    left:10,
                    right:10,
                    show:'true',
                    borderWidth:'2',
                    borderColor:"#9a9898cf",
                },
                xAxis: {
                    type: 'category',
                    data: ['D', 'I', 'S', 'C'],
                    position: 'top',
                    nameTextStyle: {
                        borderColor: "#9a9898cf",
                        borderWidth: 2
                    },
                    axisTick: {
                        show: true,
                        length: '0',
                        lineStyle: {
                            width:2
                        }
                    },
                    axisLabel: {
                        show: false
                    }
                },
                yAxis: {
                    show:false,
                    type: 'value',
                    max: 120,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
                series: [
                    {
                        name: '压力情境下的行为风格',
                        type: 'line',
                        data: this.lData,
                        symbol: 'circle', //折线点设置为实心点
                        symbolSize: 10, //折线点的大小
                        smooth: true,
                        markLine : {
                            symbol:"none",
                            itemStyle:{
                                normal:{
                                    color:'#FA8565',
                                }
                            },
                            data : [
                                {
                                    silent:false, //鼠标悬停事件
                                     lineStyle:{ //警戒线的样式
                                        type:"solid", //样式  ‘solid’和‘dotted‘
                                        color:"#c82d31",
                                        width: 2   //宽度
                                    },
                                    yAxis: 51,
                                    label: {
                                        normal: {
                                            formatter: ''
                                        }
                                    }
                                },
                                {
                                    silent:false, //鼠标悬停事件
                                    lineStyle:{ //警戒线的样式
                                        type:"solid", //样式  ‘solid’和‘dotted‘
                                        color:"#9a9898cf",
                                        width: 2   //宽度
                                    },
                                    yAxis: 100,
                                    label: {
                                        normal: {
                                            formatter: ''
                                        }
                                    }
                                }
                            ]
                        },
                        markPoint: {
                            label: {
                                color: "#71a5d6",
                                fontWeight: "bold",
                                fontSize: 14
                            },
                            symbolSize:1,
                            data: [
                                {value: 'D', xAxis: 'D', yAxis: 110},
                                {value: 'I', xAxis: 'I', yAxis: 110},
                                {value: 'S', xAxis: 'S', yAxis: 110},
                                {value: 'C', xAxis: 'C', yAxis: 110},
                            ]
                        }
                    },
                    {
                        data: [0,0,0,0],
                        type: 'bar',
                        barWidth: 50,
                        showBackground: true,
                        backgroundStyle: {
                            borderColor: "#9a9898cf",
                            borderWidth: 2,
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ],
            };
            // 绘制图表
            lChart.setOption(option);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

span{
    color: #707478;
}
.text-right {
    text-align: right !important;
}
.text-left {
    font-size:18px;
    text-align: left !important;
}


.el-timeline p{
    text-align: left;
    margin:3px 0;
    font-size:18px;
}
.el-timeline div{
    font-size:18px;
}
.el-timeline span{
    font-weight: blod;
}
.card-title{
    text-align: left;
    padding: 10px 10px 5px;
    /* margin-bottom:5px; */
}
.el-card{
    margin-top:5px;
}
.el-main{
    width: 1100px;
    margin: 0 auto;
    padding-top:2px;
    padding-bottom:2px;
}
.el-timeline {
    text-align:left;
    font-size:18px !important;
}
.page-div{
    /* font-size:18px; */
    width:100%;
    height:1505px;
    padding-top:100px;
    padding-bottom:100px;
    border:0;
    /* border:1px solid black; */
}
.page-div h1{
    font-size: 24px;
}
.page-div span{
    font-size:18px;
}
.page-div .el-card__body {
    font-size:18px !important;
    padding: 5px 10px !important;
}
.el-timeline-item__timestamp{
    font-size: 18px !important;
    text-align: left !important;
}
</style>
